import React, { useEffect, useState } from 'react';
import {
  ArrowRightOutlined,
  BookOutlined,
  DollarOutlined,
  HomeFilled,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProjectOutlined,
  ProfileFilled,
  UserOutlined,
  FileAddOutlined,
  SnippetsOutlined,
  FormOutlined,
  EditOutlined,
  EditFilled,
  SnippetsFilled,
  DiffFilled
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import thTH from 'antd/locale/th_TH';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { Anchor, Button, Card, ConfigProvider, Dropdown, Flex, FloatButton, Layout, Menu, Modal, theme, Tooltip } from 'antd';  
import { Outlet, useLocation, useParams} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import moment from 'moment';
import 'moment/locale/th';
import imgdata from '../img/IMG_7282.png'
import R from '../img/LOGOVU.png'
import imgdata2 from '../img/IMG_7283.png'
import logo from '../img/VULOGO.png'
import { signout } from '../FunctionForLater';

const { Header, Sider, Content } = Layout;

moment.locale('th'); 

const siderStyle: React.CSSProperties = {
    height: '100vh',
    position: 'fixed',
     background: '#d6c7ae',
     color:'#693f21',
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 1000,
    overflow: 'auto',
    scrollbarWidth: 'thin',
  };

dayjs.locale('th'); 
  //รายการในsider
const ResBar: React.FC = () => {
    const location = useLocation();
   
    const handleMain = () => {
      navigate(`/VU_HREC`);
    };
    const [isActive, setActive] = useState(true)
    

  
    const [openMod,setopenMod] = useState(false)

  
    type MenuItem = Required<MenuProps>['items'][number];
  
    const [collapsed, setCollapsed] = useState(false);
    const [project_status,setproject_status] = useState('')
    const MenuKey = location.pathname;
    const navigate = useNavigate();
    
    
    // Check if the current path is 'BudgetReqFund'
   
    const isHome = location.pathname === `/VU_HREC`
    const isHome2 = location.pathname === `/VU_HREC/`
    const isEditProf = location.pathname === `/VU_HREC/Profile`
    const isDraft = location.pathname === `/VU_HREC/Draft`
    const isInfo = location.pathname.startsWith("/VU_HREC/ProjectInfo");
    
    const isForm =
      location.pathname === "/VU_HREC/EhticalReq" ||
      location.pathname === "/VU_HREC/VolunteerForm"||
      location.pathname === "/VU_HREC/UploadDoc";
    const {
      token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const onclickManual = async()=>{
      window.open('https://www.canva.com/design/DAGaFLPGDAA/unmMR-syskcOPtY89srNtQ/view?utm_content=DAGaFLPGDAA&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf0938878eb', '_blank');
    }
  
    const status = sessionStorage.getItem('status');
    //หน้าหลัก/ฉบับร่าง
    const items: MenuItem[] = [
      { key: '/VU_HREC', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      // {key: '/Help', icon: <QuestionCircleOutlined />, label: <a onClick={onclickManual} target="_self" rel="noopener noreferrer">: คู่มือการใช้งาน</a>},
      ...(status === 'Outsider' ? [
        { key: '/edit', icon: <UserOutlined />, label: <a href='/VU_HREC/Profile'>: แก้ไขข้อมูลส่วนตัว</a> }
      ] : []),
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    ];

    //ข้อมูล
    const Infoitems: MenuItem[] = [
      { key: '/VU_HREC', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      {
        key: '/Form',
        label: 'ฟอร์มกรอกข้อมูล',
        icon: <FormOutlined />,
        children: [
          { 
            key: '/Part1', 
            icon: <EditOutlined />, 
            label: <>
            <Tooltip title="คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์">
            <a href={`/VU_HREC/EhticalReq`}
              target="_self" 
              rel="noopener noreferrer">: คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> </Tooltip></>
          },
          { 
            key: '/Part2', 
            icon: <UserOutlined />, 
            label: <Tooltip title="แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์">
              <a onClick={()=>navigate(`/VU_HREC/VolunteerForm`)} 
            target="_self" rel="noopener noreferrer">: แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์
              </a></Tooltip> },
          { 
            key: '/Part3', 
            icon: <FileAddOutlined />, 
            label: <Tooltip title="แนบไฟล์เพื่อประกอบการยื่นคำขอ">
              <a onClick={()=>navigate(`/VU_HREC/UploadDoc`)} 
            target="_self" rel="noopener noreferrer">: แนบไฟล์
              </a></Tooltip> },

        ],
      },
      {
        key: '/Info',
        label: 'สารบัญข้อมูล',
        icon: <SnippetsOutlined />,
        children: [
          { 
            key: '/Part-1', 
            icon: <EditFilled />, 
            label: <a 
              href={`/VU_HREC/ProjectInfo#part-1`}
              target="_self" 
              rel="noopener noreferrer">: คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> 
          },
          { 
            key: '/Part-2', 
            icon: <SnippetsFilled />, 
            label: <a 
            href={`/VU_HREC/ProjectInfo#part-2`}
            target="_self" rel="noopener noreferrer">: แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> },
            { 
              key: '/Part-3', 
              icon: <DiffFilled />, 
              label: <a 
              href={`/VU_HREC/ProjectInfo#part-3`}
              target="_self" rel="noopener noreferrer">: เอกสารหลักฐานเพิ่มเติม</a> },

        ],
      },
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    ];

    const SubmittedInfoitems: MenuItem[] = [
      { key: '/VU_HREC', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      
      {
        key: '/Info',
        label: 'สารบัญข้อมูล',
        icon: <SnippetsOutlined />,
        children: [
          { 
            key: '/Part-1', 
            icon: <EditFilled />, 
            label: <a 
              href={`/VU_HREC/ProjectInfo#part-1`}
              target="_self" 
              rel="noopener noreferrer">: คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> 
          },
          { 
            key: '/Part-2', 
            icon: <SnippetsFilled />, 
            label: <a 
            href={`/VU_HREC/ProjectInfo#part-2`}
            target="_self" rel="noopener noreferrer">: แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> },
            { 
              key: '/Part-3', 
              icon: <DiffFilled />, 
              label: <a 
              href={`/VU_HREC/ProjectInfo#part-3`}
              target="_self" rel="noopener noreferrer">: เอกสารหลักฐานเพิ่มเติม</a> },

        ],
      },
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    ];

    const FormItem: MenuItem[] = [
      { key: '/VU_HREC', icon: <HomeFilled />, label: <a onClick={handleMain} target="_self" rel="noopener noreferrer">: หน้าหลัก</a> },
      { key: '/ProjectInfo', icon: <ProfileFilled />, label: <a onClick={()=>navigate(`/VU_HREC/ProjectInfo`)} target="_self" rel="noopener noreferrer">: ดูข้อมูล</a> },
      {
        key: '/Form',
        label: 'ฟอร์มกรอกข้อมูล',
        icon: <SnippetsOutlined />,
        children: [
          { 
            key: '/Part1', 
            icon: <ProfileFilled />, 
            label: <a onClick={() => {
              navigate('/VU_HREC/EhticalReq', {
                state: { scrollTo: 'part-1' },
              });
            }}
              target="_self" 
              rel="noopener noreferrer">:คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> 
          },
          { 
            key: '/Part2', 
            icon: <ProfileFilled />, 
            label: <a onClick={()=>navigate(`/VU_HREC/VolunteerForm`)} 
            target="_self" rel="noopener noreferrer">: แบบเอกสารชี้แจงอาสาสมัครเพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</a> },
          { 
            key: '/Part3', 
            icon: <ProfileFilled />, 
            label: <a onClick={()=>navigate(`/VU_HREC/UploadDoc`)} 
            target="_self" rel="noopener noreferrer">: แนบไฟล์</a> },
        ],
      },
      
      { key: '/logout', icon: <LogoutOutlined />, label: <a onClick={()=>setopenMod(true)}>: ออกจากระบบ</a> },
    ];
    
    
    function checklist() {
      if(isHome||isHome2){
        setActive(false);
      }else
      { if(sessionStorage.getItem('Order_ID')&&isInfo){
          axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status==200){
              const tmp = response.data.data.project_status;
              console.log(tmp)
              setproject_status(tmp)
            }
          })
        }
    }
      
    }
    
    useEffect(() => {
      checklist(); 
      
      const setFavicon = (iconUrl: string) => {
        const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
        if (link) {
          link.href = iconUrl;
        } else {
          const newLink = document.createElement("link");
          newLink.rel = "icon";
          newLink.href = iconUrl;
          document.head.appendChild(newLink);
        }
      };
  
      // Set external image URL as favicon
      setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
      document.title = "VU HREC"; 
      
       
    }, [location.pathname]);
    
    return (
                
      <ConfigProvider 
        locale={thTH}
        theme={{
          components: {
            Table: {
              bodySortBg:"white",
              headerBg:"#8EA3A6",
              rowHoverBg:"#E6E9AF",
              footerBg:"#8EA3A6",
              headerColor:"white",
              colorBgContainer:'white',
              headerSortHoverBg: '#748b8f',
              headerSortActiveBg: '#7b979c',
              
            },
           
            Card:{
              colorBgContainer:'white'
            },
            Menu: {
              fontFamily: 'kanit',
              itemBg: "#white",
              itemColor: "#693f21",
              itemHoverColor: "white",
              itemSelectedBg: "#ffb6b5",
              itemSelectedColor: "#805b5b",
              subMenuItemSelectedColor:"#805b5b",
              popupBg:"black"
            },
            Layout: {
              siderBg: "#FFDBB5",
              headerBg: "#954C2E",

            },
            Input: {
              activeBg: 'white',
              hoverBg: 'white',
            },
            Select: {
              optionSelectedColor: '#8174A0',
              optionActiveBg: "#E5E1DA",
              controlItemBgActive: '#E5E1DA'
          },
          },
          token: {
            fontSize: 16,
            fontFamily: 'Kanit',
            // colorBgBase: '#bfb6a8',
            colorBgElevated: 'white',
            colorBorder: "#179BAE",
          }
        }}
      >
        <Layout>
        <link rel="icon" type="image/png" href={logo} />

        
          <Sider
            width={'40vh'}
            style={siderStyle}
            trigger={null}
            collapsible
            collapsed={collapsed}
          >
            <br/>
            <Flex justify='center'>
            <img 
              src={R} 
              alt="Logos" 
              style={{ 
                width: '70%',         // Or a fixed size like '100px'
                height: 'auto',       // Maintain aspect ratio
                objectFit: 'contain', // Avoid squishing
                marginBottom: '1rem'  // Optional spacing
              }} 
            />
          </Flex>

            {/* หน้าหลัก/ดราฟท์ */}
            {(isHome||isDraft||isHome2||isEditProf) && (
              <Menu
                mode='inline'
                defaultSelectedKeys={[MenuKey]}
                items={items}
                style={{ padding: 10 }}
              />
            )}

            {
              isInfo&&<>{
                (project_status=='แก้ไข'||
                project_status=='แก้ไขข้อมูลตามผลพิจารณา')&&
                <Menu
                  mode='inline'
                  defaultSelectedKeys={[MenuKey]}
                  items={Infoitems}
                  style={{ padding: 10 }}
                />||
                <Menu
                  mode='inline'
                  defaultSelectedKeys={[MenuKey]}
                  items={SubmittedInfoitems}
                  style={{ padding: 10 }}
                />
              }</>
            }

            {
              isForm&&(
                <Menu
                mode='inline'
                defaultSelectedKeys={[MenuKey]}
                items={FormItem}
                style={{ padding: 10 }}
              />
              )
            }
            
          </Sider>
  
          <Layout
            style={{
              marginLeft: collapsed ? '80px' : '40vh', // Adjust margin based on sidebar state
              transition: 'margin-left 0.2s', // Smooth transition when collapsing
            }}
          >
            <Header
              style={{
                position: 'fixed',
                top: 0,
                left: collapsed ? '80px' : '40vh', 
                width: `calc(100% - ${collapsed ? '80px' : '40vh'})`,
                zIndex: 1001,
                padding: '0 16px', // Add padding for alignment
                background: '#EFE4D2',
                height: '64px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'left 0.3s, width 0.3s', // Smooth transitions
              }}
            >
              {/* Left Section */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                  }}
                />
                <p style={{ color: '#954C2E', margin: 0 }}>
                  ระบบยื่นคำขอพิจารณาจริยธรรมวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล
                </p>
              </div>
  
              {/* Right Section */}
              <Dropdown overlay={ <Menu>
                <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={() => setopenMod(true)}>
                  ออกจากระบบ
                </Menu.Item>
              </Menu>} trigger={['click']}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                <img
                  src={sessionStorage.getItem('user_picture') || imgdata2}
                  alt="User"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
                <p style={{ color: '#954C2E', margin: 0 }}>{sessionStorage.getItem('fullname')}</p>
              </div>
            </Dropdown>
            </Header>
            <div
                style={{
                    minHeight: '100vh', 
                    background: '#d0c9bf',
                }}>
            <Content
                style={{
                    margin: '25px 70px',
                    padding: 24,
                    minHeight: '50vh', 
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                    marginTop: '80px',
                    display: 'flex',      
                    flexDirection: 'column', 
                    overflowY: 'auto',  
                }}
                >
                <Card
                    style={{
                    height: '80vh',       
                    overflowY: 'auto',    
                    borderRadius: borderRadiusLG,
                    border:'none',
                    scrollBehavior: 'smooth',
                    }}
                >
                <Outlet/>
                <FloatButton.BackTop />
                    <Modal
                      title="ยืนยันการออกจากระบบ"
                      open={openMod}
                      onCancel={()=>setopenMod(false)}
                      footer={[
                          <><Button key="back" onClick={()=>setopenMod(false)}>
                              กลับ
                          </Button><Button type='primary' danger onClick={() => signout()}>
                              ใช่
                          </Button></>
                      ]}
                >
                คุณต้องการออกจากระบบใช่หรือไม่
                    </Modal>
                </Card>
            </Content></div>
          </Layout>
        </Layout>
      </ConfigProvider>
    );
  };
  
  export default ResBar;
  